import { EntityType } from '@frontend/common';
import { IGroup } from '@frontend/group/types';
import { CommonMessage } from '@frontend/lang';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PlatformDetailGrid } from '../../modal/platform-detail-grid/platform-detail-grid.component';
import { RolesAndLicenses } from '../../user/modal/roles-and-licenses/roles-and-licenses.component';
import { UserGroupMembersTab } from './user-group-member-card/user-group-members-tab.component';

export const UserGroupDetailsCard = ({ group }: { group: IGroup }) => (
    <div className='bg-background-surface outline-border-default inline-flex w-full flex-col items-start justify-start gap-6 self-stretch rounded-xl p-4 outline-1 outline-offset-[-1px]'>
        <div className='text-foreground-default justify-start text-xl font-semibold'>{CommonMessage.DETAIL.DETAILS}</div>
        <PlatformDetailGrid
            object={group}
            cols={2}
            order={['name']}
        />
    </div>
);

export const UserGroupMembersSection = ({ group }: { group: IGroup }) => <UserGroupMembersTab group={group} />;

export const UserGroupRolesAndLicensesSection = ({ group }: { group: IGroup }) => (
    <RolesAndLicenses
        entity_id={group.id}
        entity_type={EntityType.USER_GROUP}
    />
);

export const USER_GROUP_MEMBERS_LABEL = (
    <FormattedMessage
        id='user-group-detail-modal.members.label'
        description='Tab label for the members section in the user group detail modal'
        defaultMessage='Members'
    />
);

export const USER_GROUP_ROLES_LABEL = (
    <FormattedMessage
        id='user.roles-and-licenses'
        defaultMessage='Roles & licenses'
    />
);
